import React, { useState } from "react"
import Drawer from "@mui/material/Drawer"
import List from "@mui/material/List"
import Divider from "@mui/material/Divider"
import ListItem from "@mui/material/ListItem"
import ListItemText from "@mui/material/ListItemText"
import { Link } from "gatsby"
import MenuIcon from "@mui/icons-material/Menu"
import { useMediaQuery, useTheme } from "@mui/material"
import { MEDIA_BREAKPOINT_KEYS } from "style/style_snippets"
import { AVAILABLE_ROUTES } from "containers/Layout/components/NavBar"

const navDrawerStyle = {
  drawerButton: {
    marginRight: "20px",
    display: "flex",
    backgroundColor: "black",
    border: "none",
    borderRadius: "5px",
    padding: "5px 6px",
    ":focus": { outline: 0 },
    svg: {
      color: "white",
    },
  },
  drawerContainer: {
    ".MuiDrawer-paperAnchorLeft": {
      backgroundColor: "black",
    },
  },
  drawerMenu: {
    container: { width: 240, backgroundColor: "black" },
    list: {
      padding: 0,
    },
    listItem: {
      padding: "10px 20px",
    },
    listItemText: {
      color: "white !important",
      textTransform: "uppercase",
    },
    divider: {
      backgroundColor: "white",
    },
  },
}

const NavDrawer = () => {
  const [drawerOpen, setDrawerOpen] = useState(false)

  const toggleDrawer = open => event => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return
    }

    setDrawerOpen(open)
  }

  const menu = (
    <div
      css={navDrawerStyle.drawerMenu.container}
      role="presentation"
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
    >
      <List css={navDrawerStyle.drawerMenu.list}>
        {Object.values(AVAILABLE_ROUTES).map((route, index) => (
          <React.Fragment key={index}>
            <Link to={route.to}>
              <ListItem button css={navDrawerStyle.drawerMenu.listItem}>
                <ListItemText
                  primaryTypographyProps={{ color: "secondary" }}
                  css={navDrawerStyle.drawerMenu.listItemText}
                  primary={route.title}
                />
              </ListItem>
            </Link>
            <Divider css={navDrawerStyle.drawerMenu.divider} />
          </React.Fragment>
        ))}
      </List>
    </div>
  )

  const theme = useTheme()
  const mediaMatch = useMediaQuery(
    theme.breakpoints.up(MEDIA_BREAKPOINT_KEYS.sm)
  )
  return (
    !mediaMatch && (
      <>
        <button css={navDrawerStyle.drawerButton} onClick={toggleDrawer(true)}>
          <MenuIcon />
        </button>

        <Drawer
          css={navDrawerStyle.drawerContainer}
          anchor={"left"}
          open={drawerOpen}
          onClose={toggleDrawer(false)}
        >
          {menu}
        </Drawer>
      </>
    )
  )
}

export default NavDrawer
